<template>
  <div class="edit-demand-break">
    <div :class="s.form">
      <div class="p-2 bg-red rounded-2 fc-red mb-2">指定された時間には以後自動で予約が入りません。</div>
      <div :class="s.time_input">
        <div class="me-3 fw-bold">{{ formatTimestamp(date, 'YYYY年MM月DD日') }}</div>
        <div v-for="type in ['start', 'end']" :key="type" :class="s.time_input_select_group">
          <label :class="s.time_input_select_label">{{ type === 'start' ? '開始' : '終了' }}時間</label>
          <div :class="s.time_input_select">
            <select
              :name="`${type}Hour`"
              :id="`${type}Hour`"
              class="form-control"
              :value="this[type].hour"
              @change="selectedTime($event, type, 'hour')">
              <option :value="n - 1" v-for="n of 24" :key="n">{{ String(n - 1).padStart(2, '0') }}</option>
            </select>
            <span>：</span>
            <select
              :name="`${type}Minute`"
              :id="`${type}Minute`"
              class="form-control"
              :value="this[type].minute"
              @change="selectedTime($event, type, 'minute')">
              <option :value="(n - 1) * 10" v-for="n of 6" :key="n">{{ String((n - 1) * 10).padStart(2, '0') }}</option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="invalidStartEnd" class="text-danger mt-2">
        終了時刻は開始時刻より後に設定してください
      </div>
    </div>
    <div>
      <div :class="s.btns">
        <LargeBtn
          :disabled="!readySubmit"
          @click="regist(1)"
          color="blue">
          {{ isRegist ? '登録する' : '保存する' }}
        </LargeBtn>
      </div>
      <div :class="s.btns">
        <LargeBtn
          v-if="!isRegist"
          @click="regist(999)"
          :style="{ height: '60px' }"
          color="red">
          削除する
        </LargeBtn>
        <LargeBtn
          @click="hideModal()"
          :style="{ height: '60px' }"
          color="gray">
          閉じる
        </LargeBtn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import cf from '@/mixins/commonFunctions';
import { LargeBtn } from '@/components/parts';

export default {
  name: 'EditDemandBreak',
  components: {
    LargeBtn,
  },
  props: ['data'],
  mixins: [cf],
  data() {
    return {
      demandBreak: {
        id: null,
        demand_schedule_id: null,
        start: null,
        end: null,
      },
      date: null,
      start: {
        hour: 0,
        minute: 0,
      },
      end: {
        hour: 0,
        minute: 0,
      },
    };
  },
  created() {
    // 編集モード: data.demandBreakが存在する場合
    if (this.data?.demandBreak) {
      this.demandBreak = { ...this.data.demandBreak };

      // 既存データから日時を設定
      if (this.demandBreak.start) {
        this.start.hour = moment(this.demandBreak.start).hour();
        this.start.minute = moment(this.demandBreak.start).minute();
        this.date = moment(this.demandBreak.start).format('YYYY-MM-DD');
      }
      if (this.demandBreak.end) {
        this.end.hour = moment(this.demandBreak.end).hour();
        this.end.minute = moment(this.demandBreak.end).minute();
      }
    } else {
      // 新規登録モード
      // スケジュールIDの設定
      if (this.data?.demandSchedule?.id) {
        this.demandBreak.demand_schedule_id = this.data.demandSchedule.id;
        // スケジュール開始日を基準日とする
        this.date = moment(this.data.demandSchedule.start).format('YYYY-MM-DD');
      } else {
        // スケジュールがない場合は今日の日付
        this.date = moment().format('YYYY-MM-DD');
      }

      // 初期値: 現在時刻
      const now = moment();
      this.start.hour = now.hour();
      this.start.minute = Math.floor(now.minute() / 10) * 10; // 10分単位に丸める
      this.end.hour = now.hour() + 1;
      this.end.minute = this.start.minute;
    }

    this.updateDemandBreakTime();
  },
  computed: {
    isRegist() {
      return !this.demandBreak.id;
    },
    endpointType() {
      return this.demandBreak.id ? 'update' : 'create';
    },
    readySubmit() {
      return !this.invalidStartEnd
        && this.demandBreak.start
        && this.demandBreak.end
        && this.demandBreak.demand_schedule_id;
    },
    invalidStartEnd() {
      const start = moment(`${this.date} ${this.start.hour}:${this.start.minute}`);
      const end = moment(`${this.date} ${this.end.hour}:${this.end.minute}`);
      return start.isAfter(end) || start.isSame(end);
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    hideModal() {
      this.$store.dispatch('modal/contents/hideModal', null, { root: true });
    },

    selectedTime(event, type, timeType) {
      const value = event.target.value;
      if (type === 'start') {
        this.start[timeType] = Number(value);
      } else if (type === 'end') {
        this.end[timeType] = Number(value);
      }
      this.updateDemandBreakTime();
    },

    updateDemandBreakTime() {
      this.demandBreak.start = moment(`${this.date} ${this.start.hour}:${this.start.minute}`).format('YYYY-MM-DD HH:mm:ss');
      this.demandBreak.end = moment(`${this.date} ${this.end.hour}:${this.end.minute}`).format('YYYY-MM-DD HH:mm:ss');
    },

    regist(flag) {
      // 削除確認
      if (flag === 999 && !confirm('配車不可時間を削除してよろしいですか？')) return;

      if (flag === 1 && !this.readySubmit) return;

      this.showLoading();

      const data = {
        flag,
        label: '配車不可時間（ドライバー）',
        demand_schedule_id: this.demandBreak.demand_schedule_id,
        start: this.demandBreak.start,
        end: this.demandBreak.end,
      };

      // 更新時のみIDを追加
      if (this.endpointType === 'update') {
        data.id = this.demandBreak.id;
      }

      const labels = {
        999: '削除',
        1: this.endpointType === 'create' ? '登録' : '更新',
      };
      const action = labels[flag];

      this.axios({
        method: 'POST',
        url: '/v1/demandBreak/create',
        data,
      })
        .then(() => {
          alert(`配車不可時間を${action}しました`);
          this.hideModal();
          // ユーザー情報を更新（スケジュール情報の再取得）
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          if (error.response?.data?.isDuplicate) {
            alert('設定した時間帯に、他の配車不可時間または予約が存在します。\n別の時間帯を設定してください。');
            return;
          }
          console.log(error);
          alert(`配車不可時間の${action}に失敗しました。\n再度お試しください。`);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.form {
  label {
    color: var(--label-secondary);
    font-size: 16px;
    font-weight: 700;
  }
}
.required {
  margin-left: 4px;
  color: red;
  font-size: 13px;
}
.time_input {
  .time_input_select_group {
    .time_input_select {
      padding: 4px 12px;
      border: 1px solid var(--border-gray);
      display: flex;
      align-items: center;
      width: fit-content;
    }
    select {
      border: none;
      padding: 0;
      width: fit-content;
    }
  }
}
.btns {
  margin-top: 12px;
  display: flex;
  gap: 6px;
  > * {
    flex: 1;
  }
}
</style>
